import { render } from "./terms-and-condtion.vue?vue&type=template&id=6b9e5e30"
import script from "./terms-and-condtion.vue?vue&type=script&lang=js"
export * from "./terms-and-condtion.vue?vue&type=script&lang=js"

import "./terms-and-condtion.vue?vue&type=style&index=0&id=6b9e5e30&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__